<template>
  <div class="mers-org-combobox">
    <ngc-input-dropdown
      v-value="selectedGuids"
      multiselect
      wrap-chips
      placeholder="Select org IDs this user can access"
      :disabled="disabled"
      :options.prop="orgOptions"
      class="mers-org-dropdown"
      @change="onChange"
    />
    <ngc-button
      v-if="showRemoveButton"
      variant="base"
      :start-icon="removeIcon"
      aria-label="Remove filter"
      @click="$emit('remove-filter')"
    />
  </div>
</template>

<script>
export default {
  name: 'MersOrgCombobox',
  directives: {
    // Mirror the platform's `v-value` directive: set the element's value
    // property on insert and on every update so the Gator dropdown reliably
    // reflects the selected chips.
    value: {
      inserted (el, binding) {
        el.value = binding.value
      },
      update (el, binding) {
        el.value = binding.value
      }
    }
  },
  props: {
    mersOrgs: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
      required: false
    },
    removeIcon: {
      type: String,
      default: 'minus-circle',
      required: false
    },
    assignDropdownRef: {
      type: String,
      required: true
    }
  },
  computed: {
    selectedOrgs () {
      return Array.isArray(this.value) ? this.value : []
    },
    selectedGuids () {
      return this.selectedOrgs.map(o => o.guid)
    },
    orgOptions () {
      return this.mersOrgs.map(org => ({ label: this.displayName(org), value: org.guid }))
    }
  },
  methods: {
    onChange (event) {
      const guids = event.detail.value || []
      const orgs = guids
        .map(guid => this.mersOrgs.find(o => o.guid === guid))
        .filter(Boolean)
      this.$emit('input', orgs)
    },
    displayName (org) {
      if (org.active) {
        return org.displayName
      }
      return `${org.displayName} - inactive`
    }
  }
}
</script>

<style scoped>

.mers-org-combobox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mers-org-dropdown {
  flex: 1 1 auto;
  min-width: 0;
}

</style>
